export class Particle {
    constructor() {
        this.init();
    }

    init() {
        this.setDOM();
    }

    setDOM() {
        const container = document.querySelector(".js-particle");
        let amountWide = 100;
        let amountNrw = 70;

        if (window.innerWidth > 1920) {
            amountWide = (amountWide * window.innerWidth) / 1920;
        }

        const amount = window.innerWidth >= 835 ? amountWide : amountNrw;

        for (let i = 0; i < amount; i++) {
            const p = document.createElement("div");
            p.classList.add("circle-container");
            const c = document.createElement("div");
            c.classList.add("circle");

            p.appendChild(c);
            container.appendChild(p);
        }
    }
}
